export default "__VITE_ASSET__yjoIr4D5__"